import { useAuth0 } from "@auth0/auth0-react";
import { Stack, Text } from "@mantine/core";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { type Location, Navigate, useLocation } from "react-router";

export function LoginPage() {
  const { t } = useTranslation("auth");
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();

  const from = (location.state as { from?: Location } | null)?.from;
  const returnTo = from ? `${from.pathname}${from.search}${from.hash}` : "/";

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      void loginWithRedirect({ appState: { returnTo } });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, returnTo]);

  if (isAuthenticated) return <Navigate to={returnTo} replace />;

  return (
    <Stack align="center" gap="md">
      <img src="/favicon.svg" alt="" height={48} />
      <Text c="dimmed">{t("login.status")}</Text>
    </Stack>
  );
}
